export const selectUserProfile = (state) => state.userProfile



// WEBPACK FOOTER //
// ./web/js/userProfile/selectors.js